import type { PermissionSetEntity } from '@omnea-app/authz'
import type { QueryClient } from '@tanstack/react-query'

const RECORD_AUTHORIZATION_QUERY_KEY = 'RecordAuthorization'

export const recordAuthorizationQueryKey = (userId: string, entity: PermissionSetEntity, recordId: string) =>
  [RECORD_AUTHORIZATION_QUERY_KEY, userId, entity, recordId] as const

/** Named where there is no record to ask about, and shaped so it cannot collide with a real answer. */
export const NO_RECORD_ASKED_QUERY_KEY = [RECORD_AUTHORIZATION_QUERY_KEY, 'noRecord'] as const

export const isRecordAuthorizationQueryKey = (queryKey: readonly unknown[]): boolean =>
  queryKey[0] === RECORD_AUTHORIZATION_QUERY_KEY

/** Call after a write that changes who may do what to a record, such as a grant or a parent link; cached answers stay otherwise. */
export const invalidateRecordAuthorization = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [RECORD_AUTHORIZATION_QUERY_KEY] })
